import { Messages } from '../../../../gen-src/Localize';
import { PopoverWidget } from '@tableau/widgets';
import * as React from 'react';
import { Formatters } from '../../../../gen-src/Localize';
import { AppUrls } from '../../../app/AppUrls';
import { SearchResultItem } from '../../models/SearchResultTypes';
import { CardViewStyles } from './CardViewStyles';
import { ILocationInfo, LocationTypes } from '../../models/ILocationInfo';
import { ILink } from '../listView/dataGridCells/LinkCell';

export interface ContentCardProps {
  readonly urls: AppUrls;
  readonly content: SearchResultItem;
  readonly onResultItemSelected: () => void;
  readonly isSelected: boolean;
}

export abstract class ContentCard<Props extends ContentCardProps = ContentCardProps, State = {}> extends React.PureComponent<Props, State> {
  public getLastAccessedAt() {
    return this.props.content.lastAccessedAt ? Formatters.formatLongBestFitRelativeTime(new Date(this.props.content.lastAccessedAt)) : '';
  }

  protected getLinkForLocationType = (urls: AppUrls, isOwner: boolean, location?: ILocationInfo): ILink => {
    if (location) {
      switch (location.type) {
        case LocationTypes.PersonalSpace:
          return {
            text: Messages.personalSpaceGridLabel(),
            url: isOwner ? urls.personalSpaceUrl() : undefined,
          };
        case LocationTypes.Project:
          return {
            text: location.name,
            url: urls.projectUrl(location.id),
          };
        default:
          return {
            text: '',
            url: '',
          };
      }
    } else {
      return {
        text: '',
        url: '',
      };
    }
  };

  public renderInfoIconAndPopover(renderPopoverContent: () => JSX.Element) {
    return (
      <div>
        <PopoverWidget
          placement="bottom-start"
          popoverContent={renderPopoverContent()}
          title={''}
          triggerElement={<button className={CardViewStyles.InfoButton} aria-label={Messages.More_info()}></button>}
        />
      </div>
    );
  }
}

export function getContentUrlForItem(content: SearchResultItem): string {
  return content.url || '';
}
